import Dexie from 'dexie';

let DB;

const initDB = () => {
  const db = new Dexie('JADB');

  db.version(6).stores({
    suivisDrafts: '++editID, date, id',
    punchData: 'date',
    cmData: 'id, cmtype'
  });

  return db;
};

const getDB = () => {
  if (!DB) {
    DB = initDB();
  }

  const idb = DB.backendDB();

  try {
    // Check if connection to idb did not close in the meantime
    idb.transaction('tasks').abort();
  } catch (error) {
    // DB.close();

    DB = initDB();
  }

  return DB;
};

export default getDB;
